/*
Form to Adding/Editing/Deleting users in Admin Tab
*/


import { useEffect, useState } from "react";
import { Modal, Button, Table, Spinner, Alert, Form } from "react-bootstrap";
// import authApi from "services/authApi";
import http from "services/httpClient";

interface User {
  id: number;
  email: string;
  global_role: string;
  client_role: string;
  is_active: boolean;
  date_created: string;
}

interface Props {
  clientId: number;
  show: boolean;
  onClose: () => void;
  onUserChange?: () => void;
}

function ViewUsersModal({ clientId, show, onClose, onUserChange }: Props) {
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [newEmail, setNewEmail] = useState("");
  const [role, setRole] = useState("viewer");
  const [availableUsers, setAvailableUsers] = useState<User[]>([]);
  // const [clientRole, setClientRole] = useState<string | null>(null);

  const fetchAvailableUsers = async () => {
      try {
          const { data } = await http.get(`/users`);
          // filter out users already in the client
          const filtered = data.filter((u: User) =>
          !users.some(existing => existing.email === u.email)
          );
          setAvailableUsers(filtered);
      } catch (err) {
          // console.error("Failed to load available users", err);
      }
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await http.get(`/clients/${clientId}/users`);
      const data = await response.data;

      setUsers(data.users || data); // supports both formats
      // if (data.current_role) {
      //   setClientRole(data.current_role);
      // }
    } catch (err: any) {
      setError("Failed to load users.");
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddUser = async () => {
    if (!newEmail.trim()) return;
    try {
      await http.post(`/clients/${clientId}/users`, {
        email: newEmail,
        role,
      });
      
      await fetchUsers(); 
      setNewEmail("");

      await fetchAvailableUsers();
      onUserChange?.();
    } catch (err: any) {
      setError("Failed to add user.");
      // console.error(err);
    }
  };

  const handleDeleteUser = async (userId: number) => {
    if (!window.confirm("Delete this user from client?")) return;
    try {
      await http.delete(`/clients/${clientId}/users/${userId}`);
      setUsers((prev) => prev.filter((u) => u.id !== userId));
      onUserChange?.()
    } catch (err: any) {
      setError("Failed to delete user.");
      // console.error(err);
    }
  };

    useEffect(() => {
        if (show) {
            fetchUsers();
            fetchAvailableUsers();
        }
    }, [show]);


  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Client Users</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}

        <div className="mb-3 d-flex gap-2">
          <Form.Select
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            >
            <option value="">Select user</option>
            {availableUsers.map((u) => (
                <option key={u.id} value={u.email}>
                {u.email}
                </option>
            ))}
            </Form.Select>
            <Form.Select value={role} onChange={(e) => setRole(e.target.value)}>
                <option value="viewer">Viewer</option>
                <option value="manager">Manager</option>
                {/* <option value="admin">Admin</option> */}
            </Form.Select>

          <Button variant="primary" onClick={handleAddUser}>
            Add User
          </Button>
        </div>

        {loading ? (
          <Spinner animation="border" />
        ) : (
          <div style={{ overflowX: "auto" }}>
            <Table bordered hover responsive="sm">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Global Role</th>
                  <th>Client Role</th>
                  {/* <th>Active</th> */}
                  <th>Created</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id}>
                    <td>{u.email}</td>
                    <td>{u.global_role}</td>
                    <td>{u.client_role}</td>
                    {/* <td>{u.is_active ? "Yes" : "No"}</td> */}
                    <td style={{ whiteSpace: "nowrap" }}>
                      {new Date(u.date_created).toLocaleString()}
                    </td>
                    <td>
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => handleDeleteUser(u.id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ViewUsersModal;
